import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/file.png'


const _withScopeId = n => (_pushScopeId("data-v-6579a1f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-grid p-col-12 p-lg-11 p-mt-6 p-justify-between" }
const _hoisted_2 = { class: "p-col-12 p-lg-4 p-pr-6 p-pb-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "My Stats", -1))
const _hoisted_4 = { class: "p-d-flex p-flex-column p-ai-center p-justify-center stat-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Overall Monthly Earning so far", -1))
const _hoisted_6 = { class: "p-d-flex p-flex-column p-ai-center p-justify-center stat-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total Monthly Clicks so far", -1))
const _hoisted_8 = { class: "p-col-12 p-lg-8 p-pl-12" }
const _hoisted_9 = { class: "p-d-flex p-justify-between p-pb-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Latest Campaign Performances", -1))
const _hoisted_11 = { class: "p-col-12" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "data-title" }, "CONTRACT NAME", -1))
const _hoisted_13 = { class: "p-d-flex p-ai-center p-text-bold p-pl-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "file-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_15 = { class: "id-number" }
const _hoisted_16 = { class: "p-d-flex p-ai-center" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  class: "p-text-bold",
  style: {"color":"black"}
}
const _hoisted_19 = {
  key: 0,
  class: "p-d-flex p-ai-center"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  class: "p-text-bold",
  style: {"color":"black"}
}
const _hoisted_22 = { class: "p-d-flex p-justify-center" }
const _hoisted_23 = {
  key: 0,
  class: "period"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 1,
  class: "period"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "data-title" }, "STATUS", -1))
const _hoisted_33 = { class: "status-block p-d-flex p-ai-center" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status" }, null, -1))
const _hoisted_35 = { class: "status-tittle" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "button-more" }, "...")
], -1))
const _hoisted_37 = { class: "p-col-12 p-mt-6 p-pr-6" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-justify-between" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "name" }, "Recommended Campaign"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "see",
    style: {"margin-right":"-1.2%"}
  }, "See all >")
], -1))
const _hoisted_39 = { class: "p-mt-4 p-d-flex p-flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AskHint = _resolveComponent("AskHint")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_LatestCampaignItem = _resolveComponent("LatestCampaignItem")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_AskHint, {
          class: "hint",
          "tooltip-text": 'default text'
        }),
        _createElementVNode("h1", null, _toDisplayString($setup.totalOveral?.amount) + " " + _toDisplayString($setup.totalOveral?.currency || "USD"), 1),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_AskHint, {
          class: "hint",
          "tooltip-text": 'default text'
        }),
        _createElementVNode("h1", null, _toDisplayString($setup.totalOveral?.monthlyClicks), 1),
        _hoisted_7
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", {
          class: "see",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('seeAll')))
        }, "See all >")
      ]),
      _createElementVNode("section", _hoisted_11, [
        _createVNode(_component_DataTable, {
          value: $props.latestContracts,
          responsiveLayout: "scroll"
        }, {
          empty: _withCtx(() => [
            _createTextVNode(" No data found. ")
          ]),
          loading: _withCtx(() => [
            _createTextVNode(" Loading data... Please wait. ")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, null, {
              header: _withCtx(() => [
                _hoisted_12
              ]),
              body: _withCtx(({ data }) => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", _hoisted_15, "#" + _toDisplayString(data.id), 1)
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "BRAND" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_16, [
                  (data?.brand?.photo.length > 0)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: data?.brand?.photo,
                        class: "logo-brand"
                      }, null, 8, _hoisted_17))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(data?.brand?.name), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "CREATOR" }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString($setup.getCurrentChannelInfo(data)) + " ", 1),
                ($setup.user.isAgencyOwner())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      ($setup.currentChannelInfo?.channelPhoto)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: $setup.currentChannelInfo?.channelPhoto,
                            class: "logo-brand"
                          }, null, 8, _hoisted_20))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_21, _toDisplayString($setup.currentChannelInfo?.channelName), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "EARNINGS GENERATED SO FAR",
              sortField: "period"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_22, [
                  ($setup.user.isAgencyOwner())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                        (data?.paymentMethod === $setup.CampaignPaymentMethod.CPM)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              ($setup.cpmStats && $setup.cpmStats?.hasOwnProperty(data?.id))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString($setup.cpmStats[data?.id]?.amount) + " " + _toDisplayString($setup.cpmStats[data?.id]?.currency || "USD"), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_25, "0.00 USD"))
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString($setup.getMonthlyEarnings(data, true)?.forPay?.total > 0 ? 
                    $setup.getMonthlyEarnings(data, true)?.forPay?.total : (0.0).toFixed(2)) + " " + _toDisplayString($setup.getMonthlyEarnings(data, true)?.forPay?.currency || "USD"), 1)
                            ], 64))
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.user.isCreator())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                        (data?.paymentMethod === $setup.CampaignPaymentMethod.CPC)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString($setup.getMonthlyEarnings(data, false)?.forPay?.amount > 0 ? 
                    $setup.getMonthlyEarnings(data, false)?.forPay?.amount : (0.0).toFixed(2)) + " " + _toDisplayString($setup.getMonthlyEarnings(data, false)?.forPay?.currency || "USD"), 1))
                          : _createCommentVNode("", true),
                        (data?.paymentMethod === $setup.CampaignPaymentMethod.CPI)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString($setup.getMonthlyEarnings(data, false)?.forPay?.total > 0 ? 
                    $setup.getMonthlyEarnings(data, false)?.forPay?.total : (0.0).toFixed(2)) + " " + _toDisplayString($setup.getMonthlyEarnings(data, false)?.forPay?.currency || "USD"), 1))
                          : _createCommentVNode("", true),
                        (data?.paymentMethod === $setup.CampaignPaymentMethod.CPM)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              ($setup.cpmStats && $setup.cpmStats?.hasOwnProperty(data?.id))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString($setup.cpmStats[data?.id]?.amount) + " " + _toDisplayString($setup.cpmStats[data?.id]?.currency || "USD"), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_31, "0.00 USD"))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, null, {
              header: _withCtx(() => [
                _hoisted_32
              ]),
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("span", _hoisted_35, _toDisplayString(data?.status), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, null, {
              body: _withCtx(() => [
                _hoisted_36
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _hoisted_38,
      _createElementVNode("div", _hoisted_39, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.applications, (item, index) => {
          return (_openBlock(), _createBlock(_component_LatestCampaignItem, {
            class: "p-mb-3",
            item: item,
            key: `${index}_apply`
          }, null, 8, ["item"]))
        }), 128))
      ])
    ])
  ]))
}